import Icon from '@components/v2/ui/Icon/Icon';
import { Grid, IconButton } from '@mui/material';
import { Pencil } from 'lucide-react';
import { memo } from 'react';
import ShoppingProductButton from './ShoppingProductButton';
import { useProductActionsStyles } from './styles/productActions.styles';
import { ProductActionsProps } from './types/productActions.types';

const ProductActions = ({
  loading,
  isShopping,
  canAddShopping,
  shoppingButtonTooltipMessage,
  onEdit,
  onClickShopping,
}: ProductActionsProps) => {
  const { classes } = useProductActionsStyles();

  return (
    <Grid
      container
      wrap="nowrap"
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Grid>
        <ShoppingProductButton
          isLoading={loading}
          isShopping={isShopping}
          canAddShopping={canAddShopping}
          onClickShopping={onClickShopping}
          shoppingButtonTooltipMessage={shoppingButtonTooltipMessage}
        />
      </Grid>
      {onEdit && (
        <Grid>
          <IconButton onClick={onEdit} size="small" className={classes.editButton}>
            <Icon icon={Pencil} size="md" />
          </IconButton>
        </Grid>
      )}
    </Grid>
  );
};

export default memo(ProductActions);
